<template>
  <div id="app">
    <b-container>
      <div class="content-page">
        <div v-if="isEnable">
          <Header :data="data"></Header>
          <router-view></router-view>
        </div>
        <div v-else class="content-off">
          <div class="title-off">
            <h3>Página fuera de servicio</h3>
            <img src="@/assets/notfound.svg" width="150px" height="150px" />
            <p>
              La página esta fuera de servicio temporalmente, por favor intente en
              otro momento.
            </p>
          </div>
        </div>
      </div>
      <Footer class="footer-can" :data="data"></Footer>
    </b-container>    
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer
  },
  data: function() {
    return {
      data: null,
      isEnable: true,
    };
  },
  methods: {
    ...mapActions("pse", {
      loadHeadpage: "loadHeadpage",
    }),
    ...mapGetters("pse", {
      getHeadPage: "getHeadPage",
    }),
    ...mapMutations("pse", {
      setHeadPage: "setHeadPage",
    }),
  },
  mounted: async function() {
    try {
      let dataHeaded = await this.loadHeadpage();
      if (
        !dataHeaded ||
        dataHeaded.status != 200 ||
        dataHeaded.data.status == "error"
      ) {
        throw "Sin respuesta";
      }

      this.setHeadPage(dataHeaded.data.data);
      this.data = this.getHeadPage();
    }catch(er) {      
      this.isEnable = false;
      return;
    }

    try{
      if (window.location.hash.includes('#/liquidacionInyCoDecla')) {
        const params = window.location.hash.split('?')[1].split('&');
        const mm = params[0].split('=')[1];
        const liq = params[1].split('=')[1];
        this.$router.push(
                {
                    name: "LiquidacionInyCoDeclaLiq",
                    params: {
                        mm: mm,
                        liq: liq
                    }
                }
            );
      }
    } catch (er) {
      this.$router.push('/');      
    }
  },
};
</script>

<style>

h3{
  text-transform: uppercase;
}

img{
      margin: 1rem;
}

.content-off{
  display: flex;
  height: 100vh;
  align-items: center;
}

.title-off {
  width: 100%;
  text-align: center;
}

.text-description {
  margin-bottom: 1.5rem;
  text-align: justify;
}

.item-list-service {
  cursor: pointer;
}

#app {
  margin-top: 2rem;
}

.content-page{
  min-height: calc(100vh - 200px);
}

.footer-can{
  margin-top: 2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-top: 1px solid #0000004d;
}

</style>
